import { getFieldValue, Text, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import React from 'react';
import classNames from 'classnames/bind';
import withStyles from 'lib/enhancers/withStyles';
import compose from 'lib/enhancers/compose';
import styles from './SeasonDetail.module.scss';
import ShowSummaryWithLinks from './ShowSummaryWithLinks';

import type { RecordOfFields } from 'models/fields';
import type { SeasonDetailProps } from 'models/podcasts-types';
import SeasonEpisodes from './SeasonEpisodes';
import Hosts from './Hosts';

const cx = classNames.bind(styles);

// See same implementation in PodcastListing.tsx
const SeasonDetail = (props: SeasonDetailProps): React.JSX.Element => {
  const { className, fields } = props;
  const { description, showDetails, episodes, hosts } = fields;
  const { sitecoreContext } = useSitecoreContext();

  const titleHeadingLevelItemField = fields.titleHeadingLevel?.fields as RecordOfFields;
  const titleHeadingLevelValue = getFieldValue<string>(titleHeadingLevelItemField, 'Value') || 'h2';
  const titleTextStyleItemField = fields.titleTextStyle?.fields as RecordOfFields;
  const titleTextStyleValue = getFieldValue<string>(titleTextStyleItemField, 'Value') || 'font-style-xl';

  return (
    <div className={cx('podcasts-season-details', className)}>
      {sitecoreContext.pageEditing ? (
        <Text field={description} tag="div" encode={sitecoreContext.pageEditing} />
      ) : (
        <div
          dangerouslySetInnerHTML={{
            __html: '<p>' + String(description.value)?.replace(/\r\n/g, '</p><p>') + '</p>',
          }}
        />
      )}

      <ShowSummaryWithLinks showDetails={showDetails} />
      <SeasonEpisodes
        episodes={episodes}
        episodesFallbackImage={showDetails.fallbackImage}
        titleHeadingLevel={titleHeadingLevelValue}
        titleTextStyle={titleTextStyleValue}
      />

      <Hosts hosts={hosts} fallbackHosts={showDetails?.hosts} personFallbackImage={showDetails.personFallbackImage} />
    </div>
  );
};

export default compose<SeasonDetailProps>(withStyles())(SeasonDetail);
